
import React, { useState } from 'react'
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { useHistory, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@mui/styles/";
import MenuItem from "@mui/material/MenuItem";
import firebase from "../../utils/firebase";
const useStyles = makeStyles({
    cartCard: {
        borderBottomWidth: 1,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        paddingVertical: 5,
        paddingBottom: 5,
        marginVertical: 5
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
    },
    productItemCounterView: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',

    },
    productPriceView: {
        marginTop: 10,
        justifyContent: "flex-end",
        flexDirection: "column",
        alignItems: "center",
    },
    counterValue: {
        fontSize: 20,
        fontWeight: '500',
    },

    toggleCounterButton: {
        paddingHorizontal: 10,
        fontSize: 20,
    },
    discountedPriceText: {
        color: "green",
        fontWeight: "bold",
        fontSize: 13,
    },
    actualPriceText: {
        color: "#222",
        color: "red",
        fontWeight: "bold",
        textAlignVertical: "bottom", marginTop: 3, marginLeft: 8,
        textDecorationLine: "line-through",
        fontSize: 11,
    },
})

const NotificationItem = ({ notification }) => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    //const {isAnonymous } = useAuthentication();
   // const priceAfterDiscount = !!notification.discount && Number(notification.discount) > 0 ? notification.price - (notification.price * (Number(notification.discount) / 100)) : undefined;
    const styles = useStyles();
    const customTheme = useTheme();
    const handleClick =async ()=>{
        if(!!notification?.data?.productId){
        if(!notification?.isOpended && !!notification?.id){
            await firebase.firestore().collection('notifications').doc(notification?.id).set({
                ...notification,
                isOpened:true,
            }, {merge: true})
        }
        history.push('/product/'+notification?.data?.productId);
    }
    }
    return (
        <MenuItem onClick={()=> handleClick()}>
        <div style={{ width: "100%", paddingTop: 10, paddingBottom: 10, }}>
            <div className={styles.cartCard} style={{ borderColor: customTheme.dark.primary, }}>
                {!!notification?.data?.productImage &&<div onClick={() => ()=> handleClick()} className={styles.info} style={{ cursor: "pointer" }}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>

                        { notification?.data?.productImage != '' && <img src={notification?.data?.productImage} style={{ width: 60, height: 60, resizeMode: 'contain' }} />}
                    </div>
                </div>}
                {notification && !!notification?.title  && <div onClick={() => ()=> handleClick()} className={styles.info} style={{ cursor: "pointer" }} >
                    <Typography style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: 5, fontSize: 13, fontWeight: '400', color: "gray", }}>
                        {notification.title ?? ""}
                    </Typography>
                    <Typography style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: 10, fontSize: 13, fontWeight: '400', color: "gray" }}>
                    {notification?.message ?? ""}
                    </Typography>
                    {/* {notification.price && (<div style={{ display: "flex", flexDirection: "row", marginRight: 5 }} >
                        <div className={styles.productPriceView}>
                            <Typography className={styles.discountedPriceText}>{`${new Number(!priceAfterDiscount ? notification.price * quantity : priceAfterDiscount * quantity).toFixed(2)} ${t('product.currency')}`}</Typography>
                            {priceAfterDiscount && priceAfterDiscount > 0 && <Typography className={styles.actualPriceText}>{`${new Number(notification.price * quantity).toFixed(2)} ${t('product.currency')}`}</Typography>}
                        </div>
                    </div>

                    )} */}
                </div>}
            </div>
        </div>
        </MenuItem>
    );
}

export default NotificationItem;